module.exports = __webpack_public_path__ + "5a5a5c5bf2f87e90e078dcd1f0c3dfd6.png";